const trainDes = {
    title: `掼蛋赛事策划师培训班`,
    fee: '500',
    hostNo: '',
    hostName: '',
    undertakeNo: '',
    undertakeName: '',
    image1: '',
    image2: '',
    image3: '',
    phone: '',
    content: `1、掼蛋裁判自我修养与提高\n2、竞技掼蛋规则判罚解读\n3、掼蛋赛事组织与策划\n4、掼蛋赛事规范与礼仪\n5、掼蛋编排原理与系统使用\n6、掼蛋俱乐部运营管理及盈利模式`,
    equity: `1、获得掼一把平台掼蛋赛事策划师（初级）证书\n2、学会掼蛋裁判、掼蛋编排、掼蛋俱乐部运营管理\n3、获得掼蛋AI编排系统一套（市场价2000元/年）、获得掼蛋协会/掼蛋俱乐部会员管理系统一套（市场价2000元/年）\n4、获得同频同学100人高端资源\n5、获得更多所在城市和全国担任掼蛋比赛裁判长、编排长机会	\n6、获得掼蛋赛事策划师晋升通道，掼蛋赛事初级策划师—掼蛋赛事中级策划师—掼蛋赛事高级策划师—掼蛋赛事王牌策划师—金牌掼蛋赛事策划师`,
    notice: ` 1、参加人员要求身体健康，年龄18—65周岁，有以下疾病患者请勿报名参加培训：（1）先天性心脏病和风湿性心脏病患者；（2）高血压和脑血管疾病患者；（3）心肌炎和其它心脏病患者；（4）冠状动脉病患者和严重心律不齐者；（5）血糖过高或过低的糖尿病患者；（6）其他不适合智力运动的疾病患者。\n2、请先注册成为掼一把会员，再登录报名。\n3、凡持有体育部门或掼蛋协会颁发的掼蛋裁判员或掼蛋体育指导员，或政府部门网站上公示已经获得掼蛋裁判资格的，在注册后，上传相关证明，24小时内，获得掼蛋赛事策划师管理权限。此权限可以发布掼蛋赛事，使用掼一把掼蛋编排系统。终生免费，市场价2000元/年。如需培训，每人500元。如不具备以上资格，培训费每人1000元。均含掼蛋裁判服一件、午餐一顿、培训手册一本、随手礼一份，其它交通食宿、保险等费用自理。`,    
    discipline: `为保证学习效果，现邀请全体掼蛋赛事策划师，以良好的精神风貌参与到本期培训课程，并自觉做到：\n1、积极主动，全程参与，自觉出席本次安排的所有培训课程及活动，并确保不无故中途退出，中途退出者，不予发放培训证书；\n2、上课前请将手机调至静音状态或关机，并将手机集中存放，凡中间手机响起或取用手机者，每次乐捐100元；\n3、上课不迟到、不早退。迟到或早退一次乐捐100元，累计迟到、早退次数加起来达三次，不予发放培训证书；\n4、遵守课堂纪律，尊重讲师，尊重同学，未受邀请，不在教室中随意走动，未受邀请，不在课程进行中随意发言或与他人交谈；\n5、在教室、餐厅及公共场所禁止吸烟；\n6、课程进行期间禁止饮酒。\n诚挚感谢各位掼蛋赛事策划师的支持和配合！`,
    letter: `1、我完全了解自己的身体状况，确认自己的健康状况良好，没有任何身体不适或重大疾病。因此我郑重声明，可以正常参加本次培训。\n2、我愿意遵守比赛期间主办方各项规定，如果本人在参加培训过程中发现或注意到任何风险和潜在风险，本人将立刻终止比赛并及时报告工作人员。\n3、我充分了解在培训期间会有潜在危险，以及可能受伤或发生安全事故，我会竭尽所能，以对自己安全负责任的态度参加比赛，对发生不可预测的安全事故，均由自己负责。\n4、我同意接受承办方在培训期间提供的常规急救和治疗，如送医院急救和治疗及死亡所发生的相关费用由本人负担。\n本人已认真阅读、全面理解以上内容，且对上述所有内容予以确认并承担相应的法律责任，本人签署此责任书系自愿。\n学员签名:`
}
export default trainDes


// WEBPACK FOOTER //
// ./src/config/trainDes.js